function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from 'react';

var _ref =
/*#__PURE__*/
React.createElement("title", null, "Leeks");

var SvgComponent = function SvgComponent(props) {
  return React.createElement("svg", _extends({
    viewBox: "0 0 60 60"
  }, props), _ref, React.createElement("path", {
    d: "M56.08,19.41a1,1,0,0,1-.53.76L34.68,31.64s0,0,0,0L16.18,52.9l0,0a4.94,4.94,0,0,1-3.45,1.53h-.12a4.84,4.84,0,0,1-1.51-.26l-.66,1.61a1,1,0,0,1-.95.64.88.88,0,0,1-.39-.08A1,1,0,0,1,8.5,55l.77-1.86-.09-.07-.49-.49L7,54.35a1,1,0,0,1-.73.3,1,1,0,0,1-.73-1.76l1.73-1.73-.35-.34c-.07-.08-.12-.17-.19-.24l-1.88.77a1.07,1.07,0,0,1-.39.07,1,1,0,0,1-.39-2l1.65-.67a4.9,4.9,0,0,1,1.21-4.92L7,43.76l0,0L27.94,25.49a1.18,1.18,0,0,1,.22-.27L39.68,4.3a1,1,0,0,1,.76-.53,1.07,1.07,0,0,1,.87.29l4.33,4.33L48,6A1,1,0,0,1,49.5,6l4.36,4.36a1,1,0,0,1,0,1.46l-2.4,2.41,4.32,4.33A1,1,0,0,1,56.08,19.41Z",
    style: {
      "fill": "#05350f"
    }
  }), React.createElement("path", {
    d: "M28.85,27.44,8.38,45.27l0,0a2.87,2.87,0,0,0,0,4.05l1.07,1.08h0l1.13,1.13h0l0,0a2.84,2.84,0,0,0,2.05.79,2.87,2.87,0,0,0,2-.87L32.47,31.05Z",
    style: {
      "fill": "#f6f2d6"
    }
  }), React.createElement("polygon", {
    points: "45.51 12.28 42.91 16.94 49.46 13.29 51.67 11.07 48.77 8.18 46.56 10.39 45.51 12.28",
    style: {
      "fill": "#acf252"
    }
  }), React.createElement("polygon", {
    points: "33.65 29.31 44.38 10.06 40.82 6.5 30.18 25.84 33.65 29.31",
    style: {
      "fill": "#1d9a46"
    }
  }), React.createElement("polygon", {
    points: "40.99 20.37 36.63 28.22 53.35 19.02 49.79 15.47 40.99 20.37",
    style: {
      "fill": "#1d9a46"
    }
  }));
};

export default __webpack_public_path__ + "static/media/Leeks.7232191c.svg";
export { SvgComponent as ReactComponent };